import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mb-10" }
const _hoisted_3 = { class: "text-2xl font-black mb-2" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "shadow overflow-hidden border-b border-gray-200 w-2/3 bg-white" }
const _hoisted_7 = { class: "w-full divide-y divide-gray-200" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
    }, " Section "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
    }, " Status "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
    }, " Progress ")
  ])
], -1)
const _hoisted_9 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_12 = { class: "text-sm font-medium text-brand" }
const _hoisted_13 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-center" }
const _hoisted_14 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_15 = { class: "flex flex-col shadow overflow-hidden border-b border-gray-200 w-1/3 md:ml-10 bg-white min-h-full" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "block px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-center w-full bg-gray-50 border-b" }, " Overall Progress ", -1)
const _hoisted_17 = { class: "flex h-full w-full items-center justify-between" }
const _hoisted_18 = { class: "block w-full text-center text-6xl font-black py-auto" }
const _hoisted_19 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatusBadge = _resolveComponent("StatusBadge")!

  return (_ctx.form)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.form.data.name), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.form.data.description), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("tbody", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.sections, (section) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: section.id,
                    class: _normalizeClass(['hover:bg-gray-50 cursor-pointer']),
                    onClick: ($event: any) => (_ctx.onRowSelection(section.id))
                  }, [
                    _createElementVNode("td", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(section.data.name), 1)
                    ]),
                    _createElementVNode("td", _hoisted_13, [
                      _createVNode(_component_StatusBadge, {
                        status: section.data.status
                      }, null, 8, ["status"])
                    ]),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(section.data.progress) + "% ", 1)
                  ], 8, _hoisted_10))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.form.data.progress) + "% ", 1)
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_19, " Loading Form... "))
}